<template>
  <h3>{{ header }}</h3>
  <p v-for="resource in resources">
    <template v-if="!isEditing">
      <div v-if="!resource.embed_video"
           class="wrapper">
        <strong v-if="resource.title !== null">{{ resource.title }}</strong>
        <a :href="resource.url"
           target="_blank">
          {{ resource.description }}
          <i class="bi bi-box-arrow-up-right"></i>
        </a>
      </div>

      <div v-if="resource.embed_video"
           class="wrapper">
        <strong>
          {{ resource.title }}
        </strong>
        <iframe v-if="resource.embed_video"
                :src="resource.url"
                :title="resource.title"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen>
        </iframe>
      </div>

    </template>
    <template v-else>
      <div class="entryBox">
        <label class="form-label">
          {{ $t('TrainingResourceCategoryComponent.title') }}
          <input type="text"
                 v-model="resource.title"
                 class="form-control rounded-pill"/>
        </label>
        <label class="form-label">
          {{ $t('TrainingResourceCategoryComponent.linkDescription') }}
          <input type="text"
                 v-model="resource.description"
                 class="form-control rounded-pill"/>
        </label>
        <label class="form-label">
          {{ $t('TrainingResourceCategoryComponent.link') }}
          <input type="text"
                 v-model="resource.url"
                 class="form-control rounded-pill"/>
        </label>
        <span>
          <input type="checkbox"
                 id="embedding"
                 class="mx-1"
                 v-model="resource.embed_video">
          <label for="embedding"
                 class="form-label">
            {{ $t('TrainingResourceCategoryComponent.embedVideo') }}
          </label>
          <button class="btn btn-sm btn-danger mx-3 mt-1 p-1"
                  type="button"
                  @click="deleteEntry">
            <i class="bi bi-trash"></i>
          </button>
        </span>
      </div>
    </template>
  </p>
  <div v-if="isEditing"
       style="display: block; padding-top:1%; padding-bottom:1%;">
    <button class="btn btn-sm btn-primary"
            v-if="!showAddFields"
            @click="startEntryAdding">
      <i class="bi bi-plus"></i> {{ $t('add') }}
    </button>
    <div class="addEntryBox bg-primary text-white" v-if="showAddFields">
      <span class="form-label">
        {{ $t('new') }} {{ $t('TrainingResourceCategoryComponent.title') }}
      </span>
      <label class="form-label">
        <input type="text"
               class="form-control rounded-pill"
               v-model="newEntry.title"/>
        {{ $t('new') }} {{ $t('TrainingResourceCategoryComponent.linkDescription') }}
      </label>

      <label class="form-label">
        <input type="text"
               class="form-control rounded-pill"
               v-model="newEntry.description"/>
        {{ $t('new') }} {{ $t('TrainingResourceCategoryComponent.link') }}
      </label>
      <input type="text"
             class="form-control rounded-pill"
             v-model="newEntry.url"/>
      <span>
        <input type="checkbox"
               id="newEmbedding"
               class="mx-1"
               v-model="newEntry.embed_video">
        <label for="newEmbedding"
               class="form-label">{{ $t('TrainingResourceCategoryComponent.embedVideo') }}</label>
        <button class="btn btn-sm btn-success mx-1 mt-1 p-1"
                type="button"
                @click="saveNewEntry">
            <i class="bi bi-plus-circle"></i>
        </button>
        <button class="btn btn-sm btn-danger mx-1 mt-1 p-1"
                type="button"
                @click="cancelNewEntry">
            <i class="bi bi-trash"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      required: true
    },
    resources: {
      type: Array,
      required: true
    },
    isEditing: {
      type: Boolean,
    }
  },
  data() {
    return {
      showAddFields: false,
      newEntry: {
        title: '',
        description: '',
        url: '',
        embed_video: false,
      },
    }
  },
  methods: {
    deleteEntry() {

    },
    startEntryAdding() {
      this.showAddFields = true;
    },
    cancelNewEntry() {
      this.showAddFields = false;
      this.clearNewFields();
    },
    saveNewEntry() {
      this.showAddFields = false;
      console.log(this.newEntry)
      //this.resources.push(this.newEntry);
      this.clearNewFields();
    },
    clearNewFields() {
      this.newEntry.title = "";
      this.newEntry.description = "";
      this.newEntry.url = "";
      this.newEntry.embed_video = false;
    }
  },
}
</script>

<style scoped>
a {
  display: block;
}

.wrapper {
  padding-top: 1%;
  padding-bottom: 1%;
}

iframe {
  border: 0;
  width: 100%;
  min-height: 350px;
}

.entryBox {
  border: 1px solid #63432A;
  display: block;
  padding: 1%;
}

.addEntryBox {
  border: 1px solid #63432A;
  padding: 1%;
}
</style>